import { useCallback, useEffect } from 'react';
import { Moment } from 'moment';
import { useActiveMarker, useMarkerStore } from '../../../../store/markerStore';
import Api from '../../../../api/Api';
import useAuthStore from '../../../../store/authStore';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../../../queries/queryKeys';

export const useDatasetParameters = (
  namePanel: string,
  coordinates: number[],
  datasetId: string
) => {
  const point = useActiveMarker();
  const setCellSize = useMarkerStore((state) => state.setCellSize);
  const setWaterDepth = useMarkerStore((state) => state.setWaterDepth);
  const userGroupPermissions = useAuthStore(
    (state) => state.userGroupPermissions
  );

  const depthAndCellSizeQuery = useQuery({
    queryKey: [QUERY_KEYS.dataset.waterDepth, coordinates, datasetId],
    queryFn: async () => {
      return await Api.detail.getWaterDepthAndCell(coordinates, datasetId);
    },
    enabled: !!datasetId && !!coordinates && !!point?.id,
  });

  useEffect(() => {
    if (depthAndCellSizeQuery.data && point?.id) {
      const [depth, cellSize] = depthAndCellSizeQuery.data;
      setWaterDepth(point.id, namePanel, depth);
      setCellSize(point.id, namePanel, cellSize);
    }
  }, [depthAndCellSizeQuery.data]);

  const disabledDate = useCallback(
    (current: Moment): boolean => {
      if (!point || !userGroupPermissions[point?.id]?.[namePanel]) {
        return false;
      }

      // Can not select days outside dataset's time range
      return (
        (current &&
          current.isBefore(
            userGroupPermissions[point.id][namePanel].dateRange[0],
            'day'
          )) ||
        (current &&
          current.isAfter(
            userGroupPermissions[point.id][namePanel].dateRange[1],
            'day'
          ))
      );
    },
    [userGroupPermissions, point?.id, namePanel]
  );

  return {
    disabledDate,
  };
};
